var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M9 3.6001C7.0908 3.6001 6.3 4.8247 6.3 6.3001C6.3 6.7969 6.53789 7.29619 6.53789 7.29619C6.44249 7.35139 6.28384 7.52683 6.32344 7.83643C6.39724 8.41363 6.64782 8.55919 6.80742 8.57119C6.86802 9.10999 7.4478 9.7999 7.65 9.9001V10.7052C7.2 12.0552 3.6 11.8501 3.6 15.0001H14.4C14.4 11.8501 10.8 12.0552 10.35 10.7052V9.9001C10.5528 9.7999 11.132 9.10999 11.1926 8.57119C11.3522 8.55919 11.6028 8.41363 11.6766 7.83643C11.7162 7.52623 11.5575 7.35139 11.4621 7.29619C11.4621 7.29619 11.7 6.8455 11.7 6.3001C11.7 5.2075 11.271 4.2751 10.35 4.2751C10.35 4.2751 10.0302 3.6001 9 3.6001ZM13.5 4.79893C13.1928 4.79893 12.9314 4.85449 12.6914 4.93369C12.8228 5.34109 12.9 5.7955 12.9 6.3001C12.9 6.6193 12.8499 6.91194 12.7863 7.15674C12.8733 7.41414 12.9032 7.6972 12.866 7.9876C12.7814 8.6482 12.5249 9.09718 12.2027 9.37978C12.1091 9.60659 11.981 9.82146 11.843 10.0267C12.0134 10.3765 12.2628 10.6879 12.375 10.7509V10.7579C13.5972 11.3309 15.6 12.2941 15.6 15.0001H18C18 12.0253 15 12.4524 14.625 11.1774V10.7497C14.7936 10.6549 15.2766 10.0034 15.327 9.49463C15.4596 9.48323 15.6689 9.34628 15.7301 8.80088C15.7631 8.50808 15.6312 8.34331 15.552 8.29111C15.552 8.29111 15.75 7.8643 15.75 7.3501C15.75 6.3181 15.3924 5.4376 14.625 5.4376C14.625 5.4376 14.3586 4.79893 13.5 4.79893ZM4.5 4.8001C3.6414 4.8001 3.375 5.4376 3.375 5.4376C2.6076 5.4376 2.25 6.31927 2.25 7.35127C2.25 7.86607 2.44805 8.29111 2.44805 8.29111C2.36825 8.34271 2.23692 8.50808 2.26992 8.80088C2.33112 9.34628 2.54045 9.4844 2.67305 9.4958C2.72345 10.0046 3.2064 10.6561 3.375 10.7509V11.1774C3 12.4518 0 12.0253 0 15.0001H2.4C2.4 12.2941 4.4028 11.3315 5.625 10.7579V10.7497C5.7372 10.6867 5.98663 10.3771 6.15703 10.0267C6.01903 9.82146 5.89087 9.60541 5.79727 9.37861C5.47507 9.09661 5.21798 8.6476 5.13398 7.9876C5.09618 7.6936 5.12722 7.40599 5.21602 7.14619C5.15122 6.89959 5.1 6.6067 5.1 6.3001C5.1 5.8039 5.17025 5.34775 5.29805 4.93135C5.06105 4.85395 4.803 4.8001 4.5 4.8001Z",
          fill: "currentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }